import type { ILevelOption, TLevelOptionValue } from '../definitions'

/**
 * Szintopció érték elkérése kulcs szerint.
 * @param moduleLevelOptions - Szintopciók.
 * @param key                - Vizsgált kulcs.
 */
export default function getValueByOptionKey (
  moduleLevelOptions: ILevelOption[],
  key: string
): TLevelOptionValue | undefined {
  const value = moduleLevelOptions.find((option) => option.optionKey === key)?.optionValue

  return value
}
